import { getCookieToken } from '@/libs/cookies'
import { CREATE_ADDRESS, fetchWithToken } from '@/services'

export const CREATE_CUSTOMER_ADDRESS = `
  mutation createCustomerAddress($input: CustomerAddressInput!) {
    createCustomerAddress(input: $input) {
      city
      company
      country_code
      default_billing
      default_shipping
      district
      extension_attributes {
        attribute_code
        value
      }
      fax
      firstname
      id
      lastname
      middlename
      postcode
      prefix
      region {
        region
        region_code
        region_id
      }
      region_id
      street
      suffix
      telephone
      vat_id
      ward
      tag
    }
  }
`

export const AddaddressAction = async (values: any) => {
  const isExistUser = await getCookieToken()
  if (!isExistUser) return { status: 'error', message: "The current customer isn't authorized." }
  try {
    const response = await fetchWithToken({
      query: CREATE_ADDRESS,
      variables: {
        input: values,
      },
    }).then((res) => res?.payload)
    const token = response?.data?.createCustomerAddress
    if (!token) return { status: 'error', message: response?.errors?.[0]?.message }
    return { status: 'success', data: 'Address added successfully' }
  } catch (err) {
    return { status: 'error', message: "something's wrong" }
  }
}

export const AddCustomerAddress = async (values: any) => {
  console.log('🚀 ~ AddCustomerAddress ~ values:', values)
  try {
    const response = await fetchWithToken({
      query: CREATE_CUSTOMER_ADDRESS,
      variables: {
        input: values,
      },
    }).then((res) => res?.payload)
    const token = response?.data?.createCustomerAddress
    if (!token) return { status: 'error', message: response?.errors?.[0]?.message }
    return { status: 'success', data: 'Address added successfully' }
  } catch (err) {
    return { status: 'error', message: "something's wrong" }
  }
}
